import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface AiContentState {
  onFetchContent: (query: string) => Promise<{ status: 'success' | 'failed'; content: string[] }>;
  setOnFetchContent: (func: AiContentState['onFetchContent']) => void;
}

export const useAiContent = create<AiContentState, [['zustand/devtools', AiContentState]]>(
  devtools((set) => ({
    onFetchContent: async () => ({ content: [], status: 'success' }),
    setOnFetchContent: (func) => set({ onFetchContent: func }),
  }))
);
